export const BetType = {
  Corner_0_1_2_3: 'Corner_0_1_2_3',
  Street_0_1_2: 'Street_0_1_2',
  Street_0_2_3: 'Street_0_2_3',
  StraightUp_0: 'StraightUp_0',
  Corner_2_3_5_6: 'Corner_2_3_5_6',
  Split_0_3: 'Split_0_3',
  Split_2_3: 'Split_2_3',
  StraightUp_3: 'StraightUp_3',
  Corner_5_6_8_9: 'Corner_5_6_8_9',
  Split_3_6: 'Split_3_6',
  Split_5_6: 'Split_5_6',
  StraightUp_6: 'StraightUp_6',
  Corner_8_9_11_12: 'Corner_8_9_11_12',
  Split_6_9: 'Split_6_9',
  Split_8_9: 'Split_8_9',
  StraightUp_9: 'StraightUp_9',
  Corner_11_12_14_15: 'Corner_11_12_14_15',
  Split_9_12: 'Split_9_12',
  Split_11_12: 'Split_11_12',
  StraightUp_12: 'StraightUp_12',
  Corner_14_15_17_18: 'Corner_14_15_17_18',
  Split_12_15: 'Split_12_15',
  Split_14_15: 'Split_14_15',
  StraightUp_15: 'StraightUp_15',
  Corner_17_18_20_21: 'Corner_17_18_20_21',
  Split_15_18: 'Split_15_18',
  Split_17_18: 'Split_17_18',
  StraightUp_18: 'StraightUp_18',
  Corner_20_21_23_24: 'Corner_20_21_23_24',
  Split_18_21: 'Split_18_21',
  Split_20_21: 'Split_20_21',
  StraightUp_21: 'StraightUp_21',
  Corner_23_24_26_27: 'Corner_23_24_26_27',
  Split_21_24: 'Split_21_24',
  Split_23_24: 'Split_23_24',
  StraightUp_24: 'StraightUp_24',
  Corner_26_27_29_30: 'Corner_26_27_29_30',
  Split_24_27: 'Split_24_27',
  Split_26_27: 'Split_26_27',
  StraightUp_27: 'StraightUp_27',
  Corner_29_30_32_33: 'Corner_29_30_32_33',
  Split_27_30: 'Split_27_30',
  Split_29_30: 'Split_29_30',
  StraightUp_30: 'StraightUp_30',
  Corner_32_33_35_36: 'Corner_32_33_35_36',
  Split_30_33: 'Split_30_33',
  Split_32_33: 'Split_32_33',
  StraightUp_33: 'StraightUp_33',
  Split_33_36: 'Split_33_36',
  Split_35_36: 'Split_35_36',
  StraightUp_36: 'StraightUp_36',
  Corner_1_2_4_5: 'Corner_1_2_4_5',
  Split_0_2: 'Split_0_2',
  Split_1_2: 'Split_1_2',
  StraightUp_2: 'StraightUp_2',
  Corner_4_5_7_8: 'Corner_4_5_7_8',
  Split_2_5: 'Split_2_5',
  Split_4_5: 'Split_4_5',
  StraightUp_5: 'StraightUp_5',
  Corner_7_8_10_11: 'Corner_7_8_10_11',
  Split_5_8: 'Split_5_8',
  Split_7_8: 'Split_7_8',
  StraightUp_8: 'StraightUp_8',
  Corner_10_11_13_14: 'Corner_10_11_13_14',
  Split_8_11: 'Split_8_11',
  Split_10_11: 'Split_10_11',
  StraightUp_11: 'StraightUp_11',
  Corner_13_14_16_17: 'Corner_13_14_16_17',
  Split_11_14: 'Split_11_14',
  Split_13_14: 'Split_13_14',
  StraightUp_14: 'StraightUp_14',
  Corner_16_17_19_20: 'Corner_16_17_19_20',
  Split_14_17: 'Split_14_17',
  Split_16_17: 'Split_16_17',
  StraightUp_17: 'StraightUp_17',
  Corner_19_20_22_23: 'Corner_19_20_22_23',
  Split_17_20: 'Split_17_20',
  Split_19_20: 'Split_19_20',
  StraightUp_20: 'StraightUp_20',
  Corner_22_23_25_26: 'Corner_22_23_25_26',
  Split_20_23: 'Split_20_23',
  Split_22_23: 'Split_22_23',
  StraightUp_23: 'StraightUp_23',
  Corner_25_26_28_29: 'Corner_25_26_28_29',
  Split_23_26: 'Split_23_26',
  Split_25_26: 'Split_25_26',
  StraightUp_26: 'StraightUp_26',
  Corner_28_29_31_32: 'Corner_28_29_31_32',
  Split_26_29: 'Split_26_29',
  Split_28_29: 'Split_28_29',
  StraightUp_29: 'StraightUp_29',
  Corner_31_32_34_35: 'Corner_31_32_34_35',
  Split_29_32: 'Split_29_32',
  Split_31_32: 'Split_31_32',
  StraightUp_32: 'StraightUp_32',
  Split_32_35: 'Split_32_35',
  Split_34_35: 'Split_34_35',
  StraightUp_35: 'StraightUp_35',
  SixLine_1_2_3_4_5_6: 'SixLine_1_2_3_4_5_6',
  Split_0_1: 'Split_0_1',
  Street_1_2_3: 'Street_1_2_3',
  StraightUp_1: 'StraightUp_1',
  SixLine_4_5_6_7_8_9: 'SixLine_4_5_6_7_8_9',
  Split_1_4: 'Split_1_4',
  Street_4_5_6: 'Street_4_5_6',
  StraightUp_4: 'StraightUp_4',
  SixLine_7_8_9_10_11_12: 'SixLine_7_8_9_10_11_12',
  Split_4_7: 'Split_4_7',
  Street_7_8_9: 'Street_7_8_9',
  StraightUp_7: 'StraightUp_7',
  SixLine_10_11_12_13_14_15: 'SixLine_10_11_12_13_14_15',
  Split_7_10: 'Split_7_10',
  Street_10_11_12: 'Street_10_11_12',
  StraightUp_10: 'StraightUp_10',
  SixLine_13_14_15_16_17_18: 'SixLine_13_14_15_16_17_18',
  Split_10_13: 'Split_10_13',
  Street_13_14_15: 'Street_13_14_15',
  StraightUp_13: 'StraightUp_13',
  SixLine_16_17_18_19_20_21: 'SixLine_16_17_18_19_20_21',
  Split_13_16: 'Split_13_16',
  Street_16_17_18: 'Street_16_17_18',
  StraightUp_16: 'StraightUp_16',
  SixLine_19_20_21_22_23_24: 'SixLine_19_20_21_22_23_24',
  Split_16_19: 'Split_16_19',
  Street_19_20_21: 'Street_19_20_21',
  StraightUp_19: 'StraightUp_19',
  SixLine_22_23_24_25_26_27: 'SixLine_22_23_24_25_26_27',
  Split_19_22: 'Split_19_22',
  Street_22_23_24: 'Street_22_23_24',
  StraightUp_22: 'StraightUp_22',
  SixLine_25_26_27_28_29_30: 'SixLine_25_26_27_28_29_30',
  Split_22_25: 'Split_22_25',
  Street_25_26_27: 'Street_25_26_27',
  StraightUp_25: 'StraightUp_25',
  SixLine_28_29_30_31_32_33: 'SixLine_28_29_30_31_32_33',
  Split_25_28: 'Split_25_28',
  Street_28_29_30: 'Street_28_29_30',
  StraightUp_28: 'StraightUp_28',
  SixLine_31_32_33_34_35_36: 'SixLine_31_32_33_34_35_36',
  Split_28_31: 'Split_28_31',
  Street_31_32_33: 'Street_31_32_33',
  StraightUp_31: 'StraightUp_31',
  Split_31_34: 'Split_31_34',
  Street_34_35_36: 'Street_34_35_36',
  StraightUp_34: 'StraightUp_34',
  Red_Snake: "Red_Snake",
  Black_Snake: "Black_Snake",
  Red_Pairs: "Red_Pairs",
  Black_Pairs: "Black_Pairs",
  Tiers: "Tiers",
  Orphelins: "Orphelins",
  Voisins: "Voisins",
  Zero: "Zero",
  Finale_0: "Finale_0",
  Finale_1: "Finale_1",
  Finale_2: "Finale_2",
  Finale_3: "Finale_3",
  Finale_4: "Finale_4",
  Finale_5: "Finale_5",
  Finale_6: "Finale_6",
  Finale_7: "Finale_7",
  Finale_8: "Finale_8",
  Finale_9: "Finale_9",
  Finale: "Finale",
  Neighbors: 'Neighbors',
};

export const CombinationTypes = {
  Red_Snake: [
    BetType.StraightUp_1,
    BetType.StraightUp_5,
    BetType.StraightUp_9,
    BetType.StraightUp_12,
    BetType.StraightUp_14,
    BetType.StraightUp_16,
    BetType.StraightUp_19,
    BetType.StraightUp_23,
    BetType.StraightUp_27,
    BetType.StraightUp_30,
    BetType.StraightUp_32,
    BetType.StraightUp_34,
  ],
  Black_Snake: [
    BetType.StraightUp_2,
    BetType.StraightUp_6,
    BetType.StraightUp_8,
    BetType.StraightUp_10,
    BetType.StraightUp_13,
    BetType.Split_17_20,
    BetType.StraightUp_24,
    BetType.StraightUp_26,
    BetType.StraightUp_28,
    BetType.StraightUp_31,
    BetType.StraightUp_35,
  ],
  Red_Pairs: [
    BetType.Split_9_12,
    BetType.Split_16_19,
    BetType.Split_18_21,
    BetType.Split_27_30,
  ],
  Black_Pairs: [
    BetType.Split_8_11,
    BetType.Split_10_11,
    BetType.Split_10_13,
    BetType.Split_17_20,
    BetType.Split_26_29,
    BetType.Split_28_29,
    BetType.Split_28_31,
  ],
  Tiers: [
    BetType.Split_5_8,
    BetType.Split_10_11,
    BetType.Split_13_16,
    BetType.Split_23_24,
    BetType.Split_27_30,
    BetType.Split_33_36,
  ],
  Orphelins: [
    BetType.StraightUp_1,
    BetType.Split_6_9,
    BetType.Split_14_17,
    BetType.Split_17_20,
    BetType.Split_31_34,
  ],
  Voisins: [
    BetType.Street_0_2_3,
    BetType.Split_4_7,
    BetType.Split_12_15,
    BetType.Split_18_21,
    BetType.Split_19_22,
    BetType.Split_32_35,
    BetType.Corner_25_26_28_29,
  ],
  Zero: [
    BetType.StraightUp_26,
    BetType.Split_0_3,
    BetType.Split_12_15,
    BetType.Split_32_35,
  ],
  Finale_0: [
    BetType.StraightUp_0,
    BetType.StraightUp_10,
    BetType.StraightUp_20,
    BetType.StraightUp_30,
  ],
  Finale_1: [
    BetType.StraightUp_1,
    BetType.StraightUp_11,
    BetType.StraightUp_21,
    BetType.StraightUp_31,
  ],
  Finale_2: [
    BetType.StraightUp_2,
    BetType.StraightUp_12,
    BetType.StraightUp_22,
    BetType.StraightUp_32,
  ],
  Finale_3: [
    BetType.StraightUp_3,
    BetType.StraightUp_13,
    BetType.StraightUp_23,
    BetType.StraightUp_33,
  ],
  Finale_4: [
    BetType.StraightUp_4,
    BetType.StraightUp_14,
    BetType.StraightUp_24,
    BetType.StraightUp_34,
  ],
  Finale_5: [
    BetType.StraightUp_5,
    BetType.StraightUp_15,
    BetType.StraightUp_25,
    BetType.StraightUp_35,
  ],
  Finale_6: [
    BetType.StraightUp_6,
    BetType.StraightUp_16,
    BetType.StraightUp_26,
    BetType.StraightUp_36,
  ],
  Finale_7: [
    BetType.StraightUp_7,
    BetType.StraightUp_17,
    BetType.StraightUp_27,
  ],
  Finale_8: [
    BetType.StraightUp_8,
    BetType.StraightUp_18,
    BetType.StraightUp_28,
  ],
  Finale_9: [
    BetType.StraightUp_9,
    BetType.StraightUp_19,
    BetType.StraightUp_29,
  ],
}

export const RECTANGLE_TABLE_DATA = [
  {
    color: 'red',
    number: 3,
    right: BetType.Corner_2_3_5_6,
    left: BetType.Split_0_3,
    center: BetType.Split_2_3,
    self: BetType.StraightUp_3,
  },

  {
    color: '',
    number: 6,
    right: BetType.Corner_5_6_8_9,
    left: BetType.Split_3_6,
    center: BetType.Split_5_6,
    self: BetType.StraightUp_6,
  },

  {
    color: 'red',
    number: 9,
    right: BetType.Corner_8_9_11_12,
    left: BetType.Split_6_9,
    center: BetType.Split_8_9,
    self: BetType.StraightUp_9,
  },
  {
    color: 'red',
    number: 12,
    right: BetType.Corner_11_12_14_15,
    left: BetType.Split_9_12,
    center: BetType.Split_11_12,
    self: BetType.StraightUp_12,
  },
  {
    color: '',
    number: 15,
    right: BetType.Corner_14_15_17_18,
    left: BetType.Split_12_15,
    center: BetType.Split_14_15,
    self: BetType.StraightUp_15,
  },
  {
    color: 'red',
    number: 18,
    right: BetType.Corner_17_18_20_21,
    left: BetType.Split_15_18,
    center: BetType.Split_17_18,
    self: BetType.StraightUp_18,
  },
  {
    color: 'red',
    number: 21,
    right: BetType.Corner_20_21_23_24,
    left: BetType.Split_18_21,
    center: BetType.Split_20_21,
    self: BetType.StraightUp_21,
  },
  {
    color: '',
    number: 24,
    right: BetType.Corner_23_24_26_27,
    left: BetType.Split_21_24,
    center: BetType.Split_23_24,
    self: BetType.StraightUp_24,
  },
  {
    color: 'red',
    number: 27,
    right: BetType.Corner_26_27_29_30,
    left: BetType.Split_24_27,
    center: BetType.Split_26_27,
    self: BetType.StraightUp_27,
  },
  {
    color: 'red',
    number: 30,
    right: BetType.Corner_29_30_32_33,
    left: BetType.Split_27_30,
    center: BetType.Split_29_30,
    self: BetType.StraightUp_30,
  },
  {
    color: '',
    number: 33,
    right: BetType.Corner_32_33_35_36,
    left: BetType.Split_30_33,
    center: BetType.Split_32_33,
    self: BetType.StraightUp_33,
  },
  {
    color: 'red',
    number: 36,
    right: '',
    left: BetType.Split_33_36,
    center: BetType.Split_35_36,
    self: BetType.StraightUp_36,
  },
  {
    color: '',
    number: 2,
    right: BetType.Corner_1_2_4_5,
    left: BetType.Split_0_2,
    center: BetType.Split_1_2,
    self: BetType.StraightUp_2,
  },
  {
    color: 'red',
    number: 5,
    right: BetType.Corner_4_5_7_8,
    left: BetType.Split_2_5,
    center: BetType.Split_4_5,
    self: BetType.StraightUp_5,
  },
  {
    color: '',
    number: 8,
    right: BetType.Corner_7_8_10_11,
    left: BetType.Split_5_8,
    center: BetType.Split_7_8,
    self: BetType.StraightUp_8,
  },
  {
    color: '',
    number: 11,
    right: BetType.Corner_10_11_13_14,
    left: BetType.Split_8_11,
    center: BetType.Split_10_11,
    self: BetType.StraightUp_11,
  },
  {
    color: 'red',
    number: 14,
    right: BetType.Corner_13_14_16_17,
    left: BetType.Split_11_14,
    center: BetType.Split_13_14,
    self: BetType.StraightUp_14,
  },
  {
    color: '',
    number: 17,
    right: BetType.Corner_16_17_19_20,
    left: BetType.Split_14_17,
    center: BetType.Split_16_17,
    self: BetType.StraightUp_17,
  },
  {
    color: '',
    number: 20,
    right: BetType.Corner_19_20_22_23,
    left: BetType.Split_17_20,
    center: BetType.Split_19_20,
    self: BetType.StraightUp_20,
  },
  {
    color: 'red',
    number: 23,
    right: BetType.Corner_22_23_25_26,
    left: BetType.Split_20_23,
    center: BetType.Split_22_23,
    self: BetType.StraightUp_23,
  },
  {
    color: '',
    number: 26,
    right: BetType.Corner_25_26_28_29,
    left: BetType.Split_23_26,
    center: BetType.Split_25_26,
    self: BetType.StraightUp_26,
  },
  {
    color: '',
    number: 29,
    right: BetType.Corner_28_29_31_32,
    left: BetType.Split_26_29,
    center: BetType.Split_28_29,
    self: BetType.StraightUp_29,
  },
  {
    color: 'red',
    number: 32,
    right: BetType.Corner_31_32_34_35,
    left: BetType.Split_29_32,
    center: BetType.Split_31_32,
    self: BetType.StraightUp_32,
  },
  {
    color: '',
    number: 35,
    right: '',
    left: BetType.Split_32_35,
    center: BetType.Split_34_35,
    self: BetType.StraightUp_35,
  },
  {
    color: 'red',
    number: 1,
    right: BetType.SixLine_1_2_3_4_5_6,
    left: BetType.Split_0_1,
    center: BetType.Street_1_2_3,
    self: BetType.StraightUp_1,
  },
  {
    color: '',
    number: 4,
    right: BetType.SixLine_4_5_6_7_8_9,
    left: BetType.Split_1_4,
    center: BetType.Street_4_5_6,
    self: BetType.StraightUp_4,
  },
  {
    color: 'red',
    number: 7,
    right: BetType.SixLine_7_8_9_10_11_12,
    left: BetType.Split_4_7,
    center: BetType.Street_7_8_9,
    self: BetType.StraightUp_7,
  },
  {
    color: '',
    number: 10,
    right: BetType.SixLine_10_11_12_13_14_15,
    left: BetType.Split_7_10,
    center: BetType.Street_10_11_12,
    self: BetType.StraightUp_10,
  },
  {
    color: '',
    number: 13,
    right: BetType.SixLine_13_14_15_16_17_18,
    left: BetType.Split_10_13,
    center: BetType.Street_13_14_15,
    self: BetType.StraightUp_13,
  },
  {
    color: 'red',
    number: 16,
    right: BetType.SixLine_16_17_18_19_20_21,
    left: BetType.Split_13_16,
    center: BetType.Street_16_17_18,
    self: BetType.StraightUp_16,
  },
  {
    color: 'red',
    number: 19,
    right: BetType.SixLine_19_20_21_22_23_24,
    left: BetType.Split_16_19,
    center: BetType.Street_19_20_21,
    self: BetType.StraightUp_19,
  },
  {
    color: '',
    number: 22,
    right: BetType.SixLine_22_23_24_25_26_27,
    left: BetType.Split_19_22,
    center: BetType.Street_22_23_24,
    self: BetType.StraightUp_22,
  },
  {
    color: 'red',
    number: 25,
    right: BetType.SixLine_25_26_27_28_29_30,
    left: BetType.Split_22_25,
    center: BetType.Street_25_26_27,
    self: BetType.StraightUp_25,
  },
  {
    color: '',
    number: 28,
    right: BetType.SixLine_28_29_30_31_32_33,
    left: BetType.Split_25_28,
    center: BetType.Street_28_29_30,
    self: BetType.StraightUp_28,
  },
  {
    color: '',
    number: 31,
    right: BetType.SixLine_31_32_33_34_35_36,
    left: BetType.Split_28_31,
    center: BetType.Street_31_32_33,
    self: BetType.StraightUp_31,
  },
  {
    color: 'red',
    number: 34,
    right: '',
    left: BetType.Split_31_34,
    center: BetType.Street_34_35_36,
    self: BetType.StraightUp_34,
  },
];

export const MOBILE_RECTANGLE_TABLE_DATA = [
  {
    color: 'red',
    number: 1,
    right: BetType.SixLine_1_2_3_4_5_6,
    left: BetType.Split_0_1,
    center: BetType.Street_1_2_3,
    self: BetType.StraightUp_1,
  },
  {
    color: 'black',
    number: 2,
    right: BetType.Corner_1_2_4_5,
    left: BetType.Split_0_2,
    center: BetType.Split_1_2,
    self: BetType.StraightUp_2,
  },
  {
    color: 'red',
    number: 3,
    right: BetType.Corner_2_3_5_6,
    left: BetType.Split_0_3,
    center: BetType.Split_2_3,
    self: BetType.StraightUp_3,
  },
  {
    color: 'black',
    number: 4,
    right: BetType.SixLine_4_5_6_7_8_9,
    left: BetType.Split_1_4,
    center: BetType.Street_4_5_6,
    self: BetType.StraightUp_4,
  },
  {
    color: 'red',
    number: 5,
    right: BetType.Corner_4_5_7_8,
    left: BetType.Split_2_5,
    center: BetType.Split_4_5,
    self: BetType.StraightUp_5,
  },
  {
    color: 'black',
    number: 6,
    right: BetType.Corner_5_6_8_9,
    left: BetType.Split_3_6,
    center: BetType.Split_5_6,
    self: BetType.StraightUp_6,
  },
  {
    color: 'red',
    number: 7,
    right: BetType.SixLine_7_8_9_10_11_12,
    left: BetType.Split_4_7,
    center: BetType.Street_7_8_9,
    self: BetType.StraightUp_7,
  },
  {
    color: 'black',
    number: 8,
    right: BetType.Corner_7_8_10_11,
    left: BetType.Split_5_8,
    center: BetType.Split_7_8,
    self: BetType.StraightUp_8,
  },
  {
    color: 'red',
    number: 9,
    right: BetType.Corner_8_9_11_12,
    left: BetType.Split_6_9,
    center: BetType.Split_8_9,
    self: BetType.StraightUp_9,
  },
  {
    color: 'black',
    number: 10,
    right: BetType.SixLine_10_11_12_13_14_15,
    left: BetType.Split_7_10,
    center: BetType.Street_10_11_12,
    self: BetType.StraightUp_10,
  },
  {
    color: 'black',
    number: 11,
    right: BetType.Corner_10_11_13_14,
    left: BetType.Split_8_11,
    center: BetType.Split_10_11,
    self: BetType.StraightUp_11,
  },
  {
    color: 'red',
    number: 12,
    right: BetType.Corner_11_12_14_15,
    left: BetType.Split_9_12,
    center: BetType.Split_11_12,
    self: BetType.StraightUp_12,
  },
  {
    color: 'black',
    number: 13,
    right: BetType.SixLine_13_14_15_16_17_18,
    left: BetType.Split_10_13,
    center: BetType.Street_13_14_15,
    self: BetType.StraightUp_13,
  },
  {
    color: 'red',
    number: 14,
    right: BetType.Corner_13_14_16_17,
    left: BetType.Split_11_14,
    center: BetType.Split_13_14,
    self: BetType.StraightUp_14,
  },
  {
    color: 'black',
    number: 15,
    right: BetType.Corner_14_15_17_18,
    left: BetType.Split_12_15,
    center: BetType.Split_14_15,
    self: BetType.StraightUp_15,
  },
  {
    color: 'red',
    number: 16,
    right: BetType.SixLine_16_17_18_19_20_21,
    left: BetType.Split_13_16,
    center: BetType.Street_16_17_18,
    self: BetType.StraightUp_16,
  },
  {
    color: 'black',
    number: 17,
    right: BetType.Corner_16_17_19_20,
    left: BetType.Split_14_17,
    center: BetType.Split_16_17,
    self: BetType.StraightUp_17,
  },
  {
    color: 'red',
    number: 18,
    right: BetType.Corner_17_18_20_21,
    left: BetType.Split_15_18,
    center: BetType.Split_17_18,
    self: BetType.StraightUp_18,
  },
  {
    color: 'red',
    number: 19,
    right: BetType.SixLine_19_20_21_22_23_24,
    left: BetType.Split_16_19,
    center: BetType.Street_19_20_21,
    self: BetType.StraightUp_19,
  },
  {
    color: 'black',
    number: 20,
    right: BetType.Corner_19_20_22_23,
    left: BetType.Split_17_20,
    center: BetType.Split_19_20,
    self: BetType.StraightUp_20,
  },
  {
    color: 'red',
    number: 21,
    right: BetType.Corner_20_21_23_24,
    left: BetType.Split_18_21,
    center: BetType.Split_20_21,
    self: BetType.StraightUp_21,
  },
  {
    color: 'black',
    number: 22,
    right: BetType.SixLine_22_23_24_25_26_27,
    left: BetType.Split_19_22,
    center: BetType.Street_22_23_24,
    self: BetType.StraightUp_22,
  },
  {
    color: 'red',
    number: 23,
    right: BetType.Corner_22_23_25_26,
    left: BetType.Split_20_23,
    center: BetType.Split_22_23,
    self: BetType.StraightUp_23,
  },
  {
    color: 'black',
    number: 24,
    right: BetType.Corner_23_24_26_27,
    left: BetType.Split_21_24,
    center: BetType.Split_23_24,
    self: BetType.StraightUp_24,
  },
  {
    color: 'red',
    number: 25,
    right: BetType.SixLine_25_26_27_28_29_30,
    left: BetType.Split_22_25,
    center: BetType.Street_25_26_27,
    self: BetType.StraightUp_25,
  },
  {
    color: 'black',
    number: 26,
    right: BetType.Corner_25_26_28_29,
    left: BetType.Split_23_26,
    center: BetType.Split_25_26,
    self: BetType.StraightUp_26,
  },
  {
    color: 'red',
    number: 27,
    right: BetType.Corner_26_27_29_30,
    left: BetType.Split_24_27,
    center: BetType.Split_26_27,
    self: BetType.StraightUp_27,
  },
  {
    color: 'black',
    number: 28,
    right: BetType.SixLine_28_29_30_31_32_33,
    left: BetType.Split_25_28,
    center: BetType.Street_28_29_30,
    self: BetType.StraightUp_28,
  },
  {
    color: 'black',
    number: 29,
    right: BetType.Corner_28_29_31_32,
    left: BetType.Split_26_29,
    center: BetType.Split_28_29,
    self: BetType.StraightUp_29,
  },
  {
    color: 'red',
    number: 30,
    right: BetType.Corner_29_30_32_33,
    left: BetType.Split_27_30,
    center: BetType.Split_29_30,
    self: BetType.StraightUp_30,
  },
  {
    color: 'black',
    number: 31,
    right: BetType.SixLine_31_32_33_34_35_36,
    left: BetType.Split_28_31,
    center: BetType.Street_31_32_33,
    self: BetType.StraightUp_31,
  },
  {
    color: 'red',
    number: 32,
    right: BetType.Corner_31_32_34_35,
    left: BetType.Split_29_32,
    center: BetType.Split_31_32,
    self: BetType.StraightUp_32,
  },
  {
    color: 'black',
    number: 33,
    right: BetType.Corner_32_33_35_36,
    left: BetType.Split_30_33,
    center: BetType.Split_32_33,
    self: BetType.StraightUp_33,
  },
  {
    color: 'red',
    number: 34,
    right: '',
    left: BetType.Split_31_34,
    center: BetType.Street_34_35_36,
    self: BetType.StraightUp_34,
  },
  {
    color: 'black',
    number: 35,
    right: '',
    left: BetType.Split_32_35,
    center: BetType.Split_34_35,
    self: BetType.StraightUp_35,
  },
  {
    color: 'red',
    number: 36,
    right: '',
    left: BetType.Split_33_36,
    center: BetType.Split_35_36,
    self: BetType.StraightUp_36,
  },
];

export const REC_BET_DATA_MODEL = [
  {
    type: 'StraightUp_0',
    winNumbers: [0],
  },
  {
    type: 'StraightUp_1',
    winNumbers: [1],
  },
  {
    type: 'StraightUp_2',
    winNumbers: [2],
  },
  {
    type: 'StraightUp_3',
    winNumbers: [3],
  },
  {
    type: 'StraightUp_4',
    winNumbers: [4],
  },
  {
    type: 'StraightUp_5',
    winNumbers: [5],
  },
  {
    type: 'StraightUp_6',
    winNumbers: [6],
  },
  {
    type: 'StraightUp_7',
    winNumbers: [7],
  },
  {
    type: 'StraightUp_8',
    winNumbers: [8],
  },
  {
    type: 'StraightUp_9',
    winNumbers: [9],
  },
  {
    type: 'StraightUp_10',
    winNumbers: [10],
  },
  {
    type: 'StraightUp_11',
    winNumbers: [11],
  },
  {
    type: 'StraightUp_12',
    winNumbers: [12],
  },
  {
    type: 'StraightUp_13',
    winNumbers: [13],
  },
  {
    type: 'StraightUp_14',
    winNumbers: [14],
  },
  {
    type: 'StraightUp_15',
    winNumbers: [15],
  },
  {
    type: 'StraightUp_16',
    winNumbers: [16],
  },
  {
    type: 'StraightUp_17',
    winNumbers: [17],
  },
  {
    type: 'StraightUp_18',
    winNumbers: [18],
  },
  {
    type: 'StraightUp_19',
    winNumbers: [19],
  },
  {
    type: 'StraightUp_20',
    winNumbers: [20],
  },
  {
    type: 'StraightUp_21',
    winNumbers: [21],
  },
  {
    type: 'StraightUp_22',
    winNumbers: [22],
  },
  {
    type: 'StraightUp_23',
    winNumbers: [23],
  },
  {
    type: 'StraightUp_24',
    winNumbers: [24],
  },
  {
    type: 'StraightUp_25',
    winNumbers: [25],
  },
  {
    type: 'StraightUp_26',
    winNumbers: [26],
  },
  {
    type: 'StraightUp_27',
    winNumbers: [27],
  },
  {
    type: 'StraightUp_28',
    winNumbers: [28],
  },
  {
    type: 'StraightUp_29',
    winNumbers: [29],
  },
  {
    type: 'StraightUp_30',
    winNumbers: [30],
  },
  {
    type: 'StraightUp_31',
    winNumbers: [31],
  },
  {
    type: 'StraightUp_32',
    winNumbers: [32],
  },
  {
    type: 'StraightUp_33',
    winNumbers: [33],
  },
  {
    type: 'StraightUp_34',
    winNumbers: [34],
  },
  {
    type: 'StraightUp_35',
    winNumbers: [35],
  },
  {
    type: 'StraightUp_36',
    winNumbers: [36],
  },
  {
    type: 'Split_0_1',
    winNumbers: [0, 1],
  },
  {
    type: 'Split_0_2',
    winNumbers: [0, 2],
  },
  {
    type: 'Split_0_3',
    winNumbers: [0, 3],
  },
  {
    type: 'Split_1_2',
    winNumbers: [1, 2],
  },
  {
    type: 'Split_2_3',
    winNumbers: [2, 3],
  },
  {
    type: 'Split_4_5',
    winNumbers: [4, 5],
  },
  {
    type: 'Split_5_6',
    winNumbers: [5, 6],
  },
  {
    type: 'Split_7_8',
    winNumbers: [7, 8],
  },
  {
    type: 'Split_8_9',
    winNumbers: [8, 9],
  },
  {
    type: 'Split_10_11',
    winNumbers: [10, 11],
  },
  {
    type: 'Split_11_12',
    winNumbers: [11, 12],
  },
  {
    type: 'Split_13_14',
    winNumbers: [13, 14],
  },
  {
    type: 'Split_14_15',
    winNumbers: [14, 15],
  },
  {
    type: 'Split_16_17',
    winNumbers: [16, 17],
  },
  {
    type: 'Split_17_18',
    winNumbers: [17, 18],
  },
  {
    type: 'Split_19_20',
    winNumbers: [19, 20],
  },
  {
    type: 'Split_20_21',
    winNumbers: [20, 21],
  },
  {
    type: 'Split_22_23',
    winNumbers: [22, 23],
  },
  {
    type: 'Split_23_24',
    winNumbers: [23, 24],
  },
  {
    type: 'Split_25_26',
    winNumbers: [25, 26],
  },
  {
    type: 'Split_26_27',
    winNumbers: [26, 27],
  },
  {
    type: 'Split_28_29',
    winNumbers: [28, 29],
  },
  {
    type: 'Split_29_30',
    winNumbers: [29, 30],
  },
  {
    type: 'Split_31_32',
    winNumbers: [31, 32],
  },
  {
    type: 'Split_32_33',
    winNumbers: [32, 33],
  },
  {
    type: 'Split_34_35',
    winNumbers: [34, 35],
  },
  {
    type: 'Split_35_36',
    winNumbers: [35, 36],
  },
  {
    type: 'Split_1_4',
    winNumbers: [1, 4],
  },
  {
    type: 'Split_4_7',
    winNumbers: [4, 7],
  },
  {
    type: 'Split_7_10',
    winNumbers: [7, 10],
  },
  {
    type: 'Split_10_13',
    winNumbers: [10, 13],
  },
  {
    type: 'Split_13_16',
    winNumbers: [13, 16],
  },
  {
    type: 'Split_16_19',
    winNumbers: [16, 19],
  },
  {
    type: 'Split_19_22',
    winNumbers: [19, 22],
  },
  {
    type: 'Split_22_25',
    winNumbers: [22, 25],
  },
  {
    type: 'Split_25_28',
    winNumbers: [25, 28],
  },
  {
    type: 'Split_28_31',
    winNumbers: [28, 31],
  },
  {
    type: 'Split_31_34',
    winNumbers: [31, 34],
  },
  {
    type: 'Split_2_5',
    winNumbers: [2, 5],
  },
  {
    type: 'Split_5_8',
    winNumbers: [5, 8],
  },
  {
    type: 'Split_8_11',
    winNumbers: [8, 11],
  },
  {
    type: 'Split_11_14',
    winNumbers: [11, 14],
  },
  {
    type: 'Split_14_17',
    winNumbers: [14, 17],
  },
  {
    type: 'Split_17_20',
    winNumbers: [17, 20],
  },
  {
    type: 'Split_20_23',
    winNumbers: [20, 23],
  },
  {
    type: 'Split_23_26',
    winNumbers: [23, 26],
  },
  {
    type: 'Split_26_29',
    winNumbers: [26, 29],
  },
  {
    type: 'Split_29_32',
    winNumbers: [29, 32],
  },
  {
    type: 'Split_32_35',
    winNumbers: [32, 35],
  },
  {
    type: 'Split_3_6',
    winNumbers: [3, 6],
  },
  {
    type: 'Split_6_9',
    winNumbers: [6, 9],
  },
  {
    type: 'Split_9_12',
    winNumbers: [9, 12],
  },
  {
    type: 'Split_12_15',
    winNumbers: [12, 15],
  },
  {
    type: 'Split_15_18',
    winNumbers: [15, 18],
  },
  {
    type: 'Split_18_21',
    winNumbers: [18, 21],
  },
  {
    type: 'Split_21_24',
    winNumbers: [21, 24],
  },
  {
    type: 'Split_24_27',
    winNumbers: [24, 27],
  },
  {
    type: 'Split_27_30',
    winNumbers: [27, 30],
  },
  {
    type: 'Split_30_33',
    winNumbers: [30, 33],
  },
  {
    type: 'Split_33_36',
    winNumbers: [33, 36],
  },
  {
    type: 'Street_0_1_2',
    winNumbers: [0, 1, 2],
  },
  {
    type: 'Street_0_2_3',
    winNumbers: [0, 2, 3],
  },
  {
    type: 'Street_1_2_3',
    winNumbers: [1, 2, 3],
  },
  {
    type: 'Street_4_5_6',
    winNumbers: [4, 5, 6],
  },
  {
    type: 'Street_7_8_9',
    winNumbers: [7, 8, 9],
  },
  {
    type: 'Street_10_11_12',
    winNumbers: [10, 11, 12],
  },
  {
    type: 'Street_13_14_15',
    winNumbers: [13, 14, 15],
  },
  {
    type: 'Street_16_17_18',
    winNumbers: [16, 17, 18],
  },
  {
    type: 'Street_19_20_21',
    winNumbers: [19, 20, 21],
  },
  {
    type: 'Street_22_23_24',
    winNumbers: [22, 23, 24],
  },
  {
    type: 'Street_25_26_27',
    winNumbers: [25, 26, 27],
  },
  {
    type: 'Street_28_29_30',
    winNumbers: [28, 29, 30],
  },
  {
    type: 'Street_31_32_33',
    winNumbers: [31, 32, 33],
  },
  {
    type: 'Street_34_35_36',
    winNumbers: [34, 35, 36],
  },
  {
    type: 'Corner_0_1_2_3',
    winNumbers: [0, 1, 2, 3],
  },
  {
    type: 'Corner_1_2_4_5',
    winNumbers: [1, 2, 4, 5],
  },
  {
    type: 'Corner_2_3_5_6',
    winNumbers: [2, 3, 5, 6],
  },
  {
    type: 'Corner_4_5_7_8',
    winNumbers: [4, 5, 7, 8],
  },
  {
    type: 'Corner_5_6_8_9',
    winNumbers: [5, 6, 8, 9],
  },
  {
    type: 'Corner_7_8_10_11',
    winNumbers: [7, 8, 10, 11],
  },
  {
    type: 'Corner_8_9_11_12',
    winNumbers: [8, 9, 11, 12],
  },
  {
    type: 'Corner_10_11_13_14',
    winNumbers: [10, 11, 13, 14],
  },
  {
    type: 'Corner_11_12_14_15',
    winNumbers: [11, 12, 14, 15],
  },
  {
    type: 'Corner_13_14_16_17',
    winNumbers: [13, 14, 16, 17],
  },
  {
    type: 'Corner_14_15_17_18',
    winNumbers: [14, 15, 17, 18],
  },
  {
    type: 'Corner_16_17_19_20',
    winNumbers: [16, 17, 19, 20],
  },
  {
    type: 'Corner_17_18_20_21',
    winNumbers: [17, 18, 20, 21],
  },
  {
    type: 'Corner_19_20_22_23',
    winNumbers: [19, 20, 22, 23],
  },
  {
    type: 'Corner_20_21_23_24',
    winNumbers: [20, 21, 23, 24],
  },
  {
    type: 'Corner_22_23_25_26',
    winNumbers: [22, 23, 25, 26],
  },
  {
    type: 'Corner_23_24_26_27',
    winNumbers: [23, 24, 26, 27],
  },
  {
    type: 'Corner_25_26_28_29',
    winNumbers: [25, 26, 28, 29],
  },
  {
    type: 'Corner_26_27_29_30',
    winNumbers: [26, 27, 29, 30],
  },
  {
    type: 'Corner_28_29_31_32',
    winNumbers: [28, 29, 31, 32],
  },
  {
    type: 'Corner_29_30_32_33',
    winNumbers: [29, 30, 32, 33],
  },
  {
    type: 'Corner_31_32_34_35',
    winNumbers: [31, 32, 34, 35],
  },
  {
    type: 'Corner_32_33_35_36',
    winNumbers: [32, 33, 35, 36],
  },
  {
    type: 'SixLine_1_2_3_4_5_6',
    winNumbers: [1, 2, 3, 4, 5, 6],
  },
  {
    type: 'SixLine_4_5_6_7_8_9',
    winNumbers: [4, 5, 6, 7, 8, 9],
  },
  {
    type: 'SixLine_7_8_9_10_11_12',
    winNumbers: [7, 8, 9, 10, 11, 12],
  },
  {
    type: 'SixLine_10_11_12_13_14_15',
    winNumbers: [10, 11, 12, 13, 14, 15],
  },
  {
    type: 'SixLine_13_14_15_16_17_18',
    winNumbers: [13, 14, 15, 16, 17, 18],
  },
  {
    type: 'SixLine_16_17_18_19_20_21',
    winNumbers: [16, 17, 18, 19, 20, 21],
  },
  {
    type: 'SixLine_19_20_21_22_23_24',
    winNumbers: [19, 20, 21, 22, 23, 24],
  },
  {
    type: 'SixLine_22_23_24_25_26_27',
    winNumbers: [22, 23, 24, 25, 26, 27],
  },
  {
    type: 'SixLine_25_26_27_28_29_30',
    winNumbers: [25, 26, 27, 28, 29, 30],
  },
  {
    type: 'SixLine_28_29_30_31_32_33',
    winNumbers: [28, 29, 30, 31, 32, 33],
  },
  {
    type: 'SixLine_31_32_33_34_35_36',
    winNumbers: [31, 32, 33, 34, 35, 36],
  },
  {
    type: 'Column_1',
    winNumbers: [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
  },
  {
    type: 'Column_2',
    winNumbers: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  },
  {
    type: 'Column_3',
    winNumbers: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
  },
  {
    type: 'Dozen_1',
    winNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    type: 'Dozen_2',
    winNumbers: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  },
  {
    type: 'Dozen_3',
    winNumbers: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    type: 'Red',
    winNumbers: [
      1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
    ],
  },
  {
    type: 'Black',
    winNumbers: [
      2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35,
    ],
  },
  {
    type: 'Even',
    winNumbers: [
      2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36,
    ],
  },
  {
    type: 'Odd',
    winNumbers: [
      1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35,
    ],
  },
  {
    type: 'Numbers_1_18',
    winNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
  },
  {
    type: 'Numbers_19_36',
    winNumbers: [
      19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    ],
  },
  {
    type: 'Red_Snake',
    winNumbers: [1, 5, 9, 12, 14, 16, 19, 23, 27, 30, 32, 34],
  },
  {
    type: 'Black_Snake',
    winNumbers: [2, 6, 8, 10, 13, 24, 26, 28, 31, 35, 17, 20],
  },
  {
    type: 'Red_Pairs',
    winNumbers: [9, 12, 16, 19, 18, 21, 27, 30],
  },
  {
    type: 'Black_Pairs',
    winNumbers: [8, 10, 11, 13, 17, 20, 26, 28, 29, 31],
  },
];

export const FINAL_BET_DATA_MODEL = [
  {
    type: 'Finale_0',
    winNumbers: [0, 10, 20, 30]
  },
  {
    type: 'Finale_1',
    winNumbers: [1, 11, 21, 31]
  },
  {
    type: 'Finale_2',
    winNumbers: [2, 12, 22, 32]
  },
  {
    type: 'Finale_3',
    winNumbers: [3, 13, 23, 33]
  },
  {
    type: 'Finale_4',
    winNumbers: [4, 14, 24, 34]
  },
  {
    type: 'Finale_5',
    winNumbers: [5, 15, 25, 35]
  },
  {
    type: 'Finale_6',
    winNumbers: [6, 16, 26, 36]
  },
  {
    type: 'Finale_7',
    winNumbers: [7, 17, 27]
  },
  {
    type: 'Finale_8',
    winNumbers: [8, 18, 28]
  },
  {
    type: 'Finale_9',
    winNumbers: [9, 19, 29]
  },
];

export const OVAL_TABLE_DATA = [
  {
    value: 0
  },
  {
    value: 32
  },
  {
    value: 15
  },
  {
    value: 19
  },
  {
    value: 4
  },
  {
    value: 21
  },
  {
    value: 2
  },
  {
    value: 25
  },
  {
    value: 17
  },
  {
    value: 34
  },
  {
    value: 6
  },
  {
    value: 27
  },
  {
    value: 13
  },
  {
    value: 36
  },
  {
    value: 11
  },
  {
    value: 30
  },
  {
    value: 8
  },
  {
    value: 23
  },
  {
    value: 10
  },
  {
    value: 5
  },
  {
    value: 24
  },
  {
    value: 16
  },
  {
    value: 33
  },
  {
    value: 1
  },
  {
    value: 20
  },
  {
    value: 14
  },
  {
    value: 31
  },
  {
    value: 9
  },
  {
    value: 22
  },
  {
    value: 18
  },
  {
    value: 29
  },
  {
    value: 7
  },
  {
    value: 28
  },
  {
    value: 12
  },
  {
    value: 35
  },
  {
    value: 3
  },
  {
    value: 26
  },
]

export const BetTypeTableLeftColumns = {
  Column_3: 'Column_3',
  Column_2: 'Column_2',
  Column_1: 'Column_1',
};

export const OVAL_BET_DATA_MODEL = [
  {
    type: 'Tiers',
    winNumbers: [27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33,]
  },
  {
    type: 'Orphelins',
    winNumbers: [1, 20, 14, 31, 9, 6, 34, 17,]
  },
  {
    type: 'Voisins',
    winNumbers: [0, 2, 3, 4, 7, 12, 15, 18, 21, 19, 22, 25, 26, 28, 29, 32, 35]
  },
  {
    type: 'Zero',
    winNumbers: [12, 35, 3, 26, 0, 32, 15,]
  },
];

export const OvalTableByIndex = [
  BetType.StraightUp_0,
  BetType.StraightUp_32,
  BetType.StraightUp_15,
  BetType.StraightUp_19,
  BetType.StraightUp_4,
  BetType.StraightUp_21,
  BetType.StraightUp_2,
  BetType.StraightUp_25,
  BetType.StraightUp_17,
  BetType.StraightUp_34,
  BetType.StraightUp_6,
  BetType.StraightUp_27,
  BetType.StraightUp_13,
  BetType.StraightUp_36,
  BetType.StraightUp_11,
  BetType.StraightUp_30,
  BetType.StraightUp_8,
  BetType.StraightUp_23,
  BetType.StraightUp_10,
  BetType.StraightUp_5,
  BetType.StraightUp_24,
  BetType.StraightUp_16,
  BetType.StraightUp_33,
  BetType.StraightUp_1,
  BetType.StraightUp_20,
  BetType.StraightUp_14,
  BetType.StraightUp_31,
  BetType.StraightUp_9,
  BetType.StraightUp_22,
  BetType.StraightUp_18,
  BetType.StraightUp_29,
  BetType.StraightUp_7,
  BetType.StraightUp_28,
  BetType.StraightUp_12,
  BetType.StraightUp_35,
  BetType.StraightUp_3,
  BetType.StraightUp_26,
]
/**
 * @desc THIS CONSTANT READONLY
 * @type {{Numbers_1_18: string, Red: string, Dozen_1: string, Dozen_2: string, Numbers_19_36: string, Dozen_3: string, Even: string, Black: string, Odd: string}}
 */
export const BetTypeRectangleTableBottom = {
  Dozen_1: 'Dozen_1',
  Dozen_2: 'Dozen_2',
  Dozen_3: 'Dozen_3',
  Numbers_1_18: 'Numbers_1_18',
  Even: 'Even',
  Red: 'Red',
  Black: 'Black',
  Odd: 'Odd',
  Numbers_19_36: 'Numbers_19_36',
};

export const REC_BET_DATA_MODEL_MAP = [...REC_BET_DATA_MODEL, ...FINAL_BET_DATA_MODEL, ...OVAL_BET_DATA_MODEL]
  .reduce((item, curr) => {
    item[curr.type] = curr;
    return item;
  }, {});
